/**
 * @flow
 * @relayHash 624e8538104ba699abee6582a2a36cfa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getAttendeesPropertiesBreakdownQueryVariables = {|
  orgId: string,
  propertyIds?: ?$ReadOnlyArray<string>,
  eventIds?: ?$ReadOnlyArray<string>,
  startAt: string,
  endAt: string,
|};
export type getAttendeesPropertiesBreakdownQueryResponse = {|
  +attendeesPropertiesBreakdown: $ReadOnlyArray<{|
    +maxNoOfGuests: number,
    +rsvpedCount: number,
    +waitlistedCount: number,
    +canceledCount: number,
    +notAttendedCount: ?number,
    +attendedCount: ?number,
    +propertyName: ?string,
    +id: string,
    +title: string,
    +propertyId: string,
    +startAt: any,
    +endAt: any,
  |}>
|};
export type getAttendeesPropertiesBreakdownQuery = {|
  variables: getAttendeesPropertiesBreakdownQueryVariables,
  response: getAttendeesPropertiesBreakdownQueryResponse,
|};
*/


/*
query getAttendeesPropertiesBreakdownQuery(
  $orgId: ID!
  $propertyIds: [String!]
  $eventIds: [String!]
  $startAt: String!
  $endAt: String!
) {
  attendeesPropertiesBreakdown(orgId: $orgId, propertyIds: $propertyIds, eventIds: $eventIds, startAt: $startAt, endAt: $endAt) {
    maxNoOfGuests
    rsvpedCount
    waitlistedCount
    canceledCount
    notAttendedCount
    attendedCount
    propertyName
    id
    title
    propertyId
    startAt
    endAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "propertyIds",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "eventIds",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startAt",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endAt",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "attendeesPropertiesBreakdown",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endAt",
        "variableName": "endAt"
      },
      {
        "kind": "Variable",
        "name": "eventIds",
        "variableName": "eventIds"
      },
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "propertyIds",
        "variableName": "propertyIds"
      },
      {
        "kind": "Variable",
        "name": "startAt",
        "variableName": "startAt"
      }
    ],
    "concreteType": "Hyevent",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "maxNoOfGuests",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rsvpedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "waitlistedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "canceledCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "notAttendedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "attendedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "propertyName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "propertyId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "startAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getAttendeesPropertiesBreakdownQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getAttendeesPropertiesBreakdownQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getAttendeesPropertiesBreakdownQuery",
    "id": null,
    "text": "query getAttendeesPropertiesBreakdownQuery(\n  $orgId: ID!\n  $propertyIds: [String!]\n  $eventIds: [String!]\n  $startAt: String!\n  $endAt: String!\n) {\n  attendeesPropertiesBreakdown(orgId: $orgId, propertyIds: $propertyIds, eventIds: $eventIds, startAt: $startAt, endAt: $endAt) {\n    maxNoOfGuests\n    rsvpedCount\n    waitlistedCount\n    canceledCount\n    notAttendedCount\n    attendedCount\n    propertyName\n    id\n    title\n    propertyId\n    startAt\n    endAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bd7c6e2e4c5267170e124229a3a8d5b1';
module.exports = node;
